(function ($) {
    if(!document.querySelector('body.gp-endpoint-pos-coupons')){
        return;
    }

    var $empty = $('.pos__empty');

    //Show alert with data from input
    $(document).on("click", ".review-pos-apply-coupon__submit", function (e) {
        e.preventDefault();

        let couponCode = $('input[name="coupon_code"]').val().trim();
        let couponType = $('input[name="type"]').val();
        let $alert_rows = $('.pos__coupons_alert-row');
        $alert_rows.hide();
        if(couponType == 'gift_card'){
            let amountVal = $('input[name="amount"]').val();
            let rawAmountVal = $('input[name="rawAmount"]').val().trim();
            let currencyCode = $('input[name="currency_code"]').val().trim();
            if (amountVal === '') {
                amountVal = rawAmountVal;
            }
            amountVal = amountVal.replace(',', '.');


            var rawAmount = parseFloat(rawAmountVal) || 0;
            var amount = parseFloat(amountVal) || 0;

            let leftover = rawAmount - amount;
            if (leftover < 0) {
                leftover = 0;
            }

            let currencySymbol = '';
            if (currencyCode) {
                if (currencyCode.toLowerCase() === 'czk') {
                    currencySymbol = 'Kč';
                } else if (currencyCode.toLowerCase() === 'eur') {
                    currencySymbol = '€';
                } else {
                    currencySymbol = currencyCode.toUpperCase();
                }
            }

            let formattedAmount = amountVal.trim() !== '' ? amountVal + ' ' + currencySymbol : '';
            let formattedLeftover = formatNumber(leftover) + ' ' + currencySymbol;
            $alert_rows.eq(0).show().find('.pos__coupons_alert-content-data').text(formattedAmount);
            $alert_rows.eq(1).show().find('.pos__coupons_alert-content-data').text(formattedLeftover);
        }else{
            let displayAmount = $('input[name="displayAmount"]').val().trim();
            $alert_rows.eq(2).show().find('.pos__coupons_alert-content-data').text(displayAmount);
        }


        $('.pos__coupons_alert-headline').text(`Uplatnit poukaz ${couponCode}`);

        $('.pos__coupons_alert').show();
        setTimeout(() => {
            $('body').addClass('has-alert');
        }, 1);
    });

    //Close apply coupon alert
    $(document).on("click", ".pos__coupons_alert-close", function (e) {
        e.preventDefault();
        $('.pos__coupons_alert').hide();
        $('body').removeClass('has-alert');
    });

    //Apply coupon with alert after success
    $(document).on("click", ".pos__coupons_alert-primary", function (e) {
        e.preventDefault();
        $('.pos__coupons_alert').hide();
        $('body').removeClass('has-alert');

        let couponCode = $('input[name="coupon_code"]').val();
        let amountVal = $('input[name="amount"]').val();

        gp_ajax({
            url: ghostpress_params.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'pos_coupon_apply',
                coupon_code: couponCode,
                amount: amountVal
            },
            success: function (response) {
                if (response.success) {
                    $('.pos__header_info p').text('Poukaz ' + couponCode + ' byl úspěšně uplatněn.');
                    $('.pos__header_info').show();
                    setTimeout(function () {
                        $('.pos__header_info').fadeOut('slow');
                    }, 5000);
                } else {
                    let errorHtml = response.data.fragments.replace[".general-notices"];

                    let $parsed = $($.parseHTML(errorHtml));
                    let errorText = $parsed.text().trim();

                    alert(errorText);
                }
            },
            error: function () {
                alert('Chyba sítě, zkuste to znovu.');
            }
        });
    });

    //Format numbers
    function formatNumber(num) {
        if (num % 1 === 0) {
            return num.toString();
        }
        return parseFloat(num.toFixed(2)).toString();
    }
})(jQuery);
